import { IconProps } from './';

const defaultSize = 46;

export const SearchIcon = ({ size = defaultSize, className }: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.8229 29.6979H31.1771L30.5938 29.1354C32.6354 26.7604 33.8646 23.6771 33.8646 20.3229C33.8646 12.8438 27.8021 6.78125 20.3229 6.78125C12.8438 6.78125 6.78125 12.8438 6.78125 20.3229C6.78125 27.8021 12.8438 33.8646 20.3229 33.8646C23.6771 33.8646 26.7604 32.6354 29.1354 30.5938L29.6979 31.1771V32.8229L40.1146 43.2188L43.2188 40.1146L32.8229 29.6979ZM20.3229 29.6979C15.1354 29.6979 10.9479 25.5104 10.9479 20.3229C10.9479 15.1354 15.1354 10.9479 20.3229 10.9479C25.5104 10.9479 29.6979 15.1354 29.6979 20.3229C29.6979 25.5104 25.5104 29.6979 20.3229 29.6979Z"
        fill="white"
      />
    </svg>
  );
};
